






import Vue from 'vue';
import {PolygonjsScene} from '@polygonjs/vue2';
import {loadSceneAndMountAsync_scene_03} from '@/polygonjs/scenes/scene_03/autogenerated/loadSceneAndMountAsync';

export default Vue.extend({
  name: 'scene-03',
  components: {
    PolygonjsScene,
  },
  computed: {
    loadFunction: ()=>loadSceneAndMountAsync_scene_03,
  },
});
